import { createPortal } from 'react-dom';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { ModalWrapper } from '@/modules/perseo-billing/components';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { setIsInvoiceAndGiftCardAndClubParisModalOpen } from '@/modules/perseo-billing/store/slices/billing';
import {
  Card,
  CardHeader,
  Divider,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import {
  PdsButton,
  PdsIcon
} from '@/modules/perseo-billing/ui/react/src/components/gamma';

export const InvoiceAndGiftCardAndClubParisModal = () => {
  const dispatch = useAppDispatch();
  const isInvoiceAndGiftCardAndClubParisModalOpen = useAppSelector(
    (state) => state.billing.isInvoiceAndGiftCardAndClubParisModalOpen
  );
  const { continueWithInvoiceGtm } = useGtmBillingProduct();

  const closeModal = () => {
    continueWithInvoiceGtm('Gift Card and Club Paris');
    dispatch(setIsInvoiceAndGiftCardAndClubParisModalOpen(false));
  };

  const modalContent = (
    <ModalWrapper
      size="sm"
      open={isInvoiceAndGiftCardAndClubParisModalOpen}
      onClose={closeModal}
      roundedType="FIXED_BOTTOM"
    >
      <Card p={16}>
        <CardHeader
          pb={16}
          action={
            <div onClick={closeModal}>
              <Icon icon="CloseIcon" width={18} height={18} />
            </div>
          }
          title={
            <div className="co-flex co-gap-8px co-items-center">
              <PdsIcon
                icon="PdsInfoCircle"
                className="co-fill-pds-warning-500"
              />
              <Typography size="h3" weight="semibold">
                ¿Quieres pagar con factura?
              </Typography>
            </div>
          }
        />
        <Divider />
        <div className="co-flex co-flex-col co-gap-y-8 co-mt-4">
          <Typography>
            El pago con Gift Card y los códigos de Club Paris no están
            disponibles con factura. Por favor, elimina tu Gift Card y tu código
            de Club Paris para comprar como empresa.
          </Typography>
          <div className="co-flex co-flex-col co-w-full co-gap-y-4">
            <PdsButton onClick={closeModal} typology="primary">
              Entendido
            </PdsButton>
          </div>
        </div>
      </Card>
    </ModalWrapper>
  );

  const rootModalInvoiceAndGiftCardAndClubParis = document.getElementById(
    'modal-invoice-and-gift-card-and-club-paris'
  );
  return (
    rootModalInvoiceAndGiftCardAndClubParis &&
    createPortal(modalContent, rootModalInvoiceAndGiftCardAndClubParis)
  );
};
